import dynamic from "next/dynamic";

import useIsMobile from "@/hooks/useIsMobile";
const BoardsResultWidget = dynamic(() => import("@/screens/BoardsResult/BoardsResultPage"));
const PageLayout = dynamic(()=>import("@/screens/Layout/PageLayout"));

export default function NikayChunav({
  latestStoryData = null,
  latestVideoData = null,
  topicNewsListData = null,
  faqData = null,
}) {
 

  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={null}
        isMobileDevice={isMobileDevice}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        
        <BoardsResultWidget
          isMobileDevice={isMobileDevice}
          topicNewsListData={topicNewsListData}
          tenthResult={true}
          stateKey={"mp"}
          faqData = {faqData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    //! this page path could be a subcategory page or a content detail page based on old url
    let url = ctx?.resolvedUrl;
   
    //* remove query param from url
    url = url.split("?")[0];
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getDataByUrl } = await import(
      "@/handlers/commonApi"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    // const { toBase64 } = await import("@/utils/url");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;
    //* get redis api key for each api
    let topicDetailRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: '/education',
        page: page,
        display: 6,
        type: "all",
      },
    });
    
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    let faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "madhya-pradesh-board-10th-result-faqs" },
    });

    let [{ latestStoryData, latestVideoData }, topicNewsListData, faqData] =
      await Promise.all([
        fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
        fetchRedisWrapper(topicDetailRedisKey, () =>
          getDataByUrl({
            url: '/education',
            page: page,
            display: 6,
            type: "all",
          })
        ),
        fetchRedisWrapper(faqRedisKey, () =>
          getFaqBySlug({
            url: "madhya-pradesh-board-10th-result-faqs",
          })
        ),

      ]);

    setPageTTL(ctx, 120);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        topicNewsListData,
        faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
